export default {
    'settings.page_title': 'Settings',
    'settings.page.invitations.title': 'Team Invitations',
    'settings.page.team.title': 'The Team At ',
    'settings.page.invitations.search_results': 'Search Results',
    'settings.page.search_results': 'Search Results',
    'settings.page.team.invite': 'Invite Team Member',
    'settings.page.team.new': 'Add Team Member',
    'settings.page.team.edit': 'Edit Member Roles',
    'settings.page.team.view_self': 'Your Roles',
    'settings.page.view.invitation_title': 'View Invitation',

    'settings.link.title.profile': 'Profile',
    'settings.link.title.billing': 'Billing',
    'settings.link.title.appearance': 'Appearance',
    'settings.link.title.security': 'Security',
    'settings.link.title.organization': 'Organization',
    'settings.link.title.team': 'Team',
    'settings.link.retry': 'Click here to retry',

    'settings.checkbox.all': 'Check All',
    'settings.checkbox.actions_label': 'with selected',

    'settings.label.roles': 'Roles',
    'settings.label.user_email': 'Member Email Address',

    'settings.link.description.profile': 'Update your name, email address, and password.',
    'settings.link.description.billing': 'Ullamcorper id at suspendisse nec id volutpat vestibulum enim. Interdum blandit.',
    'settings.link.description.appearance': 'Ullamcorper id at suspendisse nec id volutpat vestibulum enim. Interdum blandit.',
    'settings.link.description.security': 'Ullamcorper id at suspendisse nec id volutpat vestibulum enim. Interdum blandit.',
    'settings.link.description.organization': "Update your organization's info.",
    'settings.link.description.team': 'Manage your team members and their roles.',

    'settings.button.update': 'Update profile',
    'settings.button.password_update': 'Update password',
    'settings.button.cancel': 'Cancel',
    'settings.button.select': 'Select',
    'settings.button.search': 'Apply',
    'settings.button.save': 'Save Changes',
    'settings.button.delete': 'Delete',
    'settings.button.edit': 'Edit',
    'settings.button.invite': 'Invite Someone',
    'settings.button.team.new': 'Add Member',
    'settings.button.team.manage': 'Manage Team',
    'settings.button.invitations.view': 'View Invitations',

    'settings.placeholder.search': 'Search team members',
    'settings.placeholder.search_invitations': 'Search invitations',

    'settings.modal.title.member_delete': 'Remove From Team',
    'settings.modal.title.invitation_delete': 'Delete Invitation',

    'settings.modal.message.member_delete': 'Are you sure that you want to remove this member from the team? | Are you sure that you want to remove these members from the team?',
    'settings.modal.message.invitation_delete': 'Are you sure that you want to delete this invitation? | Are you sure that you want to delete these invitations?',

    'settings.success.message.member_invited': 'Invitation successfully sent!',
    'settings.success.message.member_added': 'The user was successfully added to the team!',
    'settings.success.message.user_roles_updated': 'The selected roles were successfully applied to the member',
    'settings.success.message.password_updated': 'Your password was successfully updated',
    'settings.success.message.profile_updated': 'Your profile was successfully updated',
    'settings.success.message.member_deleted': 'The selected member was removed from your team | All selected members were removed from your team',
    'settings.success.message.invitation_deleted': 'The selected invitation was deleted | All selected invitations were deleted',

    'settings.error.message.member_deleted': 'This member was already removed from the team| These members were already removed from the team',
    'settings.error.message.invitation_deleted': 'This invitation was already deleted| These invitations were already deleted',
    'settings.error.message.error_loading_team': 'Sorry, there was an error loading your team',
    'settings.error.message.error_loading_invitations': 'Sorry, there was an error loading your invitations',

    'settings.activation.message.activating_message': 'Accepting invitation, one moment please',
    'settings.activation.message.success': 'Your were successfully added to the team!',
    'settings.activation.message.error': 'There was an error accepting this invitation. Please contact the sender for assistance.',
};
